export default __webpack_public_path__ + "static/media/kid3.d723e378.jpeg";